/**
 * Vista: Detalle/Nueva Póliza de Garantía
 * Formato: AMX-PVTA-FR-03
 */

import posventaService from '../services/posventa.service.js';
import tractorService from '../services/tractor.service.js';
import recepcionService from '../services/recepcion.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

export default {
  data: {
    poliza: null,
    tractor: null,
    isNew: false
  },

  async render(params) {
    this.data.isNew = !params.id || params.id === 'nueva';

    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">${this.data.isNew ? 'Nueva Póliza de Garantía' : 'Póliza de Garantía'}</h2>
          <div id="headerButtons" style="display: flex; gap: 0.5rem;">
            <button class="btn btn-secondary" onclick="router.navigate('/posventa/polizas')">&larr; Volver</button>
          </div>
        </div>
        <div id="polizaContent"><div style="text-align: center; padding: 2rem;">Cargando...</div></div>
      </div>
    `;
  },

  async afterRender(params) {
    window.polizaDetalleView = this;
    this.params = params;
    if (this.data.isNew) {
      this.renderFormularioNuevo();
    } else {
      await this.cargarPoliza(params.id);
    }
  },

  async cargarPoliza(id) {
    try {
      const response = await posventaService.obtenerPoliza(id);
      this.data.poliza = response.data || response;
      this.renderPolizaExistente();
    } catch (error) {
      toast.error('Error al cargar póliza');
      router.navigate('/posventa/polizas');
    }
  },

  renderFormularioNuevo() {
    const container = document.getElementById('polizaContent');

    container.innerHTML = `
      <form id="formPoliza">
        <!-- Buscar Tractor -->
        <div style="background: white; border: 1px solid var(--gray-200); padding: 1.25rem 1.5rem; border-radius: 8px; margin-bottom: 1rem;">
          <h4 style="margin: 0 0 0.25rem; font-size: 1rem; font-weight: 600;">Buscar por número de serie</h4>
          <p style="margin: 0 0 1rem; color: var(--text-muted); font-size: 0.85rem;">Ingrese el número de serie del tractor para cargar sus datos automáticamente</p>
          <div style="display: flex; gap: 0.75rem; align-items: center;">
            <input
              type="text"
              id="numSerieBuscar"
              class="form-input"
              style="flex: 1;"
              placeholder="Ej: TE354-2026-0127"
            />
            <button type="button" class="btn btn-primary" onclick="window.polizaDetalleView.buscarTractor()">
              Buscar
            </button>
          </div>
          <div id="tractorResult" style="margin-top: 1rem;"></div>
        </div>

        <div id="formularioPrincipal" style="display: none;">
          <input type="hidden" name="num_serie" id="numSerie" />

          <!-- Datos del Equipo -->
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
            <h3 style="margin-bottom: 1rem;">Datos del Equipo</h3>
            <div class="form-grid-2">
              <div class="form-group">
                <label class="form-label">Marca</label>
                <input type="text" id="equipoMarca" class="form-input" readonly style="background: var(--bg-secondary);" />
              </div>
              <div class="form-group">
                <label class="form-label">Modelo</label>
                <input type="text" id="equipoModelo" class="form-input" readonly style="background: var(--bg-secondary);" />
              </div>
            </div>
          </div>

          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
            <h3 style="margin-bottom: 1rem;">Datos del Propietario</h3>
            <div class="form-grid-2">
              <div class="form-group">
                <label class="form-label">Propietario</label>
                <input type="text" name="propietario" class="form-input" readonly style="background: var(--bg-secondary);" />
              </div>
              <div class="form-group">
                <label class="form-label">Teléfono</label>
                <input type="text" name="telefono" class="form-input" />
              </div>
              <div class="form-group" style="grid-column: 1 / -1;">
                <label class="form-label">Domicilio</label>
                <input type="text" name="domicilio" class="form-input" />
              </div>
            </div>
          </div>

          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
            <h3 style="margin-bottom: 1rem;">Vigencia de Garantía</h3>
            <div class="form-grid-2">
              <div class="form-group">
                <label class="form-label">Fecha de Entrega</label>
                <input type="date" name="fecha_entrega" id="fechaEntrega" class="form-input" readonly style="background: var(--bg-secondary);" />
              </div>
              <div class="form-group">
                <label class="form-label">Inicio Garantía</label>
                <input type="date" name="fecha_inicio_garantia" id="fechaInicioGarantia" class="form-input" readonly style="background: var(--bg-secondary);" />
              </div>
              <div class="form-group">
                <label class="form-label">Fin Garantía</label>
                <input type="date" name="fecha_fin_garantia" id="fechaFinGarantia" class="form-input" readonly style="background: var(--bg-secondary);" />
              </div>
              <div class="form-group">
                <label class="form-label">Horas Fin Garantía</label>
                <input type="number" name="horas_fin_garantia" class="form-input" value="2000" readonly style="background: var(--bg-secondary);" />
              </div>
            </div>
          </div>

          <div style="display: flex; gap: 1rem; justify-content: flex-end;">
            <button type="button" class="btn btn-secondary" onclick="router.navigate('/posventa/polizas')">Cancelar</button>
            <button type="submit" class="btn btn-success">Crear Póliza</button>
          </div>
        </div>
      </form>
    `;

    document.getElementById('formPoliza').addEventListener('submit', (e) => this.guardarNueva(e));

    // Buscar al presionar Enter; ocultar formulario si modifican el NS después de buscar
    const nsBuscar = document.getElementById('numSerieBuscar');
    if (nsBuscar) {
      nsBuscar.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.buscarTractor();
        }
      });
      nsBuscar.addEventListener('input', () => {
        if (this.data.tractor) {
          this.data.tractor = null;
          const fp = document.getElementById('formularioPrincipal');
          if (fp) fp.style.display = 'none';
          const result = document.getElementById('tractorResult');
          if (result) result.innerHTML = '';
        }
      });
    }
  },

  async buscarTractor() {
    const numSerie = document.getElementById('numSerieBuscar').value;
    if (!numSerie) { toast.error('Ingrese el número de serie'); return; }

    const resultDiv = document.getElementById('tractorResult');
    resultDiv.innerHTML = '<p>Buscando...</p>';

    try {
      const response = await tractorService.getByNumSerie(numSerie);
      const tractor = response.data || response;
      this.data.tractor = tractor;

      // Verificar si ya tiene póliza
      const polizaResp = await posventaService.obtenerPolizaPorNumSerie(numSerie);
      const polizaExistente = polizaResp.data !== undefined ? polizaResp.data : polizaResp;
      if (polizaExistente) {
        resultDiv.innerHTML = `
          <div style="padding: 1rem; background: var(--warning); color: white; border-radius: 8px;">
            <strong>Este tractor ya tiene una póliza de garantía registrada</strong>
          </div>
        `;
        document.getElementById('formularioPrincipal').style.display = 'none';
        return;
      }

      // Verificar que tenga entrega
      if (!tractor.fecha_entrega) {
        resultDiv.innerHTML = `
          <div style="padding: 1rem; background: var(--danger); color: white; border-radius: 8px;">
            <strong>Este tractor no tiene formato de entrega registrado.</strong><br>
            Debe completar la entrega antes de crear la póliza de garantía.
          </div>
        `;
        document.getElementById('formularioPrincipal').style.display = 'none';
        return;
      }

      resultDiv.innerHTML = '';

      document.getElementById('formularioPrincipal').style.display = 'block';
      document.getElementById('numSerie').value = numSerie;
      document.getElementById('equipoMarca').value = tractor.marca || '';
      document.getElementById('equipoModelo').value = tractor.modelo || '';

      // Auto-llenar fechas desde la entrega
      const fechaEntrega = typeof tractor.fecha_entrega === 'string'
        ? tractor.fecha_entrega.substring(0, 10)
        : new Date(tractor.fecha_entrega).toISOString().substring(0, 10);
      const fechaFin = new Date(fechaEntrega);
      fechaFin.setFullYear(fechaFin.getFullYear() + 2);
      const fechaFinStr = fechaFin.toISOString().substring(0, 10);

      document.getElementById('fechaEntrega').value = fechaEntrega;
      document.getElementById('fechaInicioGarantia').value = fechaEntrega;
      document.getElementById('fechaFinGarantia').value = fechaFinStr;

      // Auto-llenar datos del propietario si tiene cliente
      if (tractor.cliente) {
        const form = document.getElementById('formPoliza');
        form.querySelector('[name="propietario"]').value = tractor.cliente.nombre || '';
        form.querySelector('[name="telefono"]').value = tractor.cliente.telefono || '';
        form.querySelector('[name="domicilio"]').value = tractor.cliente.direccion || '';
      }
    } catch (error) {
      resultDiv.innerHTML = `<div style="padding: 1rem; background: var(--danger); color: white; border-radius: 8px;">${error.message || 'Tractor no encontrado'}</div>`;
      document.getElementById('formularioPrincipal').style.display = 'none';
    }
  },

  async guardarNueva(e) {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    if (!formData.get('propietario') || !formData.get('telefono') || !formData.get('domicilio')) {
      toast.error('Debe completar los datos del propietario');
      return;
    }

    const data = {
      num_serie: formData.get('num_serie'),
      cliente_id: this.data.tractor?.cliente_id || this.data.tractor?.cliente?.id || null,
      propietario: formData.get('propietario'),
      domicilio: formData.get('domicilio'),
      telefono: formData.get('telefono'),
      fecha_entrega: formData.get('fecha_entrega'),
      fecha_inicio_garantia: formData.get('fecha_inicio_garantia'),
      fecha_fin_garantia: formData.get('fecha_fin_garantia'),
      horas_fin_garantia: parseInt(formData.get('horas_fin_garantia')) || 2000
    };

    try {
      this._showProgress('Creando póliza...');
      const response = await posventaService.crearPoliza(data);
      this._hideProgress();
      toast.success('Póliza creada exitosamente');
      const poliza = response.data || response;
      router.navigate(`/posventa/polizas/${poliza.id}`);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al crear póliza');
    }
  },

  formatFecha(fecha) {
    if (!fecha) return '';
    const str = typeof fecha === 'string' ? fecha : fecha.toISOString();
    return str.substring(0, 10);
  },

  renderPolizaExistente() {
    const container = document.getElementById('polizaContent');
    const p = this.data.poliza;
    const readonlyBg = 'background: var(--bg-secondary);';

    container.innerHTML = `
      <form id="formEditarPoliza">
        <!-- Estado -->
        <div style="display: flex; justify-content: flex-end; margin-bottom: 1rem;">
          <span class="badge ${p.estado_garantia === 'vigente' ? 'badge-success' : 'badge-danger'}" style="font-size: 1rem; padding: 0.5rem 1rem;">
            ${p.estado_garantia === 'vigente' ? 'VIGENTE' : 'VENCIDA'}
            ${p.dias_restantes > 0 ? ` - ${p.dias_restantes} días restantes` : ''}
          </span>
        </div>

        <!-- Datos del Equipo -->
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
          <h3 style="margin-bottom: 1rem;">Datos del Equipo</h3>
          <div class="form-grid-2">
            <div class="form-group">
              <label class="form-label">Número de Serie</label>
              <input type="text" class="form-input" value="${p.num_serie}" readonly style="${readonlyBg}" />
            </div>
            <div class="form-group">
              <label class="form-label">Marca</label>
              <input type="text" class="form-input" value="${p.marca || '-'}" readonly style="${readonlyBg}" />
            </div>
            <div class="form-group">
              <label class="form-label">Modelo</label>
              <input type="text" class="form-input" value="${p.modelo || '-'}" readonly style="${readonlyBg}" />
            </div>
          </div>
        </div>

        <!-- Datos del Propietario -->
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
          <h3 style="margin-bottom: 1rem;">Datos del Propietario</h3>
          <div class="form-grid-2">
            <div class="form-group">
              <label class="form-label">Propietario</label>
              <input type="text" name="propietario" class="form-input" value="${p.propietario || ''}" readonly style="${readonlyBg}" />
            </div>
            <div class="form-group">
              <label class="form-label">Teléfono</label>
              <input type="text" name="telefono" class="form-input" value="${p.telefono || ''}" ${p.completada ? `readonly style="${readonlyBg}"` : ''} />
            </div>
            <div class="form-group" style="grid-column: 1 / -1;">
              <label class="form-label">Domicilio</label>
              <input type="text" name="domicilio" class="form-input" value="${p.domicilio || ''}" ${p.completada ? `readonly style="${readonlyBg}"` : ''} />
            </div>
          </div>
        </div>

        <!-- Vigencia -->
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
          <h3 style="margin-bottom: 1rem;">Vigencia de Garantía</h3>
          <div class="form-grid-2">
            <div class="form-group">
              <label class="form-label">Fecha de Entrega</label>
              <input type="date" class="form-input" value="${this.formatFecha(p.fecha_entrega)}" readonly style="${readonlyBg}" />
            </div>
            <div class="form-group">
              <label class="form-label">Inicio Garantía</label>
              <input type="date" class="form-input" value="${this.formatFecha(p.fecha_inicio_garantia)}" readonly style="${readonlyBg}" />
            </div>
            <div class="form-group">
              <label class="form-label">Fin Garantía</label>
              <input type="date" class="form-input" value="${this.formatFecha(p.fecha_fin_garantia)}" readonly style="${readonlyBg}" />
            </div>
            <div class="form-group">
              <label class="form-label">Horas Fin Garantía</label>
              <input type="number" class="form-input" value="${p.horas_fin_garantia}" readonly style="${readonlyBg}" />
            </div>
          </div>
        </div>

        <!-- Firmas -->
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
          <h3 style="margin-bottom: 1rem;">Firmas</h3>
          ${p.completada ? `
            <div class="form-grid-2">
              <div style="text-align: center;">
                ${p.firma_empresa_url ? `<img src="${p.firma_empresa_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />` : ''}
                <div style="border-top: 1px solid var(--gray-400); padding-top: 0.5rem; text-align: center;">
                  <strong>AGROMX</strong><br>
                  <small style="color: var(--text-muted);">Empresa</small>
                </div>
              </div>
              <div style="text-align: center;">
                ${p.firma_cliente_url ? `<img src="${p.firma_cliente_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />` : ''}
                <div style="border-top: 1px solid var(--gray-400); padding-top: 0.5rem; text-align: center;">
                  <strong>${p.propietario || '-'}</strong><br>
                  <small style="color: var(--text-muted);">Cliente</small>
                </div>
              </div>
            </div>
          ` : `
            <div class="form-grid-2">
              <div class="firma-container-new" style="text-align: center;">
                <label class="form-label firma-label">Firma AGROMX</label>
                ${p.firma_empresa_url ? `
                  <img src="${p.firma_empresa_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />
                  <a href="javascript:void(0)" class="firma-limpiar" onclick="window.polizaDetalleView.limpiarFirmaExistente('empresa')">Cambiar firma</a>
                ` : `
                  <div class="firma-box">
                    <canvas id="firma-empresa" class="firma-canvas-new"></canvas>
                    <span class="firma-placeholder">Toque para firmar</span>
                  </div>
                  <a href="javascript:void(0)" class="firma-limpiar" onclick="window.polizaDetalleView.limpiarFirma('empresa')">Limpiar</a>
                `}
              </div>
              <div class="firma-container-new" style="text-align: center;">
                <label class="form-label firma-label">Firma Propietario</label>
                ${p.firma_cliente_url ? `
                  <img src="${p.firma_cliente_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />
                  <a href="javascript:void(0)" class="firma-limpiar" onclick="window.polizaDetalleView.limpiarFirmaExistente('cliente')">Cambiar firma</a>
                ` : `
                  <div class="firma-box">
                    <canvas id="firma-cliente" class="firma-canvas-new"></canvas>
                    <span class="firma-placeholder">Toque para firmar</span>
                  </div>
                  <a href="javascript:void(0)" class="firma-limpiar" onclick="window.polizaDetalleView.limpiarFirma('cliente')">Limpiar</a>
                `}
              </div>
            </div>
          `}
        </div>

        ${!p.completada ? `
          <!-- Indicador de cambios sin guardar -->
          <div id="unsavedIndicator" style="display: none; background: var(--warning); color: white; padding: 0.5rem 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;">
            Hay cambios sin guardar
          </div>

          <!-- Botones -->
          <div style="display: flex; gap: 1rem; justify-content: flex-end; margin-bottom: 1.5rem;">
            <button type="submit" class="btn btn-success">Guardar Cambios</button>
            ${permisos.can('polizas', 'cerrar') ? `<button type="button" class="btn btn-primary" onclick="window.polizaDetalleView.completarPoliza()">Completar</button>` : ''}
          </div>
        ` : ''}
      </form>

      ${p.reportes_garantia && p.reportes_garantia.length > 0 ? `
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
          <h3 style="margin-bottom: 1rem;">Reportes de Garantía Asociados</h3>
          <div class="table-container">
            <table class="table">
              <thead>
                <tr><th>Fecha</th><th>Problema</th><th>Dictamen</th><th>Estado</th></tr>
              </thead>
              <tbody>
                ${p.reportes_garantia.map(r => `
                  <tr>
                    <td>${new Date(r.fecha_reporte).toLocaleDateString('es-MX')}</td>
                    <td>${r.descripcion_problema.substring(0, 50)}...</td>
                    <td><span class="badge ${r.dictamen === 'valida' ? 'badge-success' : r.dictamen === 'nula' ? 'badge-danger' : 'badge-secondary'}">${r.dictamen || 'Pendiente'}</span></td>
                    <td>${r.fecha_cierre ? 'Cerrado' : 'Abierto'}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        </div>
      ` : ''}

    `;

    // Mostrar botones de impresión solo si está completada
    if (p.completada) {
      const headerBtns = document.getElementById('headerButtons');
      if (permisos.canPrint('polizas')) {
        headerBtns.insertAdjacentHTML('beforeend', `
          <button class="btn btn-primary" onclick="router.navigate('/posventa/polizas/${p.id}/print')">🖨️ Imprimir</button>
          <button class="btn btn-success" onclick="window.polizaDetalleView.descargarPDF()">📄 Descargar PDF</button>
        `);
      }
    }

    // Listener para guardar cambios
    document.getElementById('formEditarPoliza').addEventListener('submit', async (e) => {
      e.preventDefault();
      if (p.completada) return;

      const formData = new FormData(e.target);
      const data = {
        telefono: formData.get('telefono'),
        domicilio: formData.get('domicilio')
      };

      try {
        this._showProgress('Subiendo firmas...');
        const firmasNuevas = await this.subirFirmas();
        if (firmasNuevas.firma_empresa_url) data.firma_empresa_url = firmasNuevas.firma_empresa_url;
        if (firmasNuevas.firma_cliente_url) data.firma_cliente_url = firmasNuevas.firma_cliente_url;

        this._showProgress('Guardando cambios...');
        await posventaService.actualizarPoliza(p.id, data);
        this._hideProgress();
        this._clearUnsaved();
        toast.success('Póliza actualizada correctamente');
        await this.cargarPoliza(p.id);
      } catch (error) {
        this._hideProgress();
        toast.error(error.message || 'Error al actualizar póliza');
      }
    });

    // Inicializar firmas si no está completada
    if (!p.completada) {
      this._hasUnsaved = false;
      this.initFirmas();
      // Detectar cambios en inputs editables
      const form = document.getElementById('formEditarPoliza');
      if (form) {
        form.querySelectorAll('input[name="telefono"], input[name="domicilio"]').forEach(input => {
          input.addEventListener('input', () => this._showUnsaved());
        });
      }
    }
  },

  async descargarPDF() {
    try {
      // Cargar html2pdf.js desde CDN si no está cargado
      if (typeof html2pdf === 'undefined') {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.2/html2pdf.bundle.min.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }

      const { default: PrintPoliza } = await import('./PrintPoliza.js');
      const p = this.data.poliza;

      // Crear contenedor temporal fuera de la vista
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = PrintPoliza.generateHTML.call(PrintPoliza, p);
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '-9999px';
      document.body.appendChild(tempDiv);

      const element = tempDiv.querySelector('.pg');
      const opt = {
        margin: 0,
        filename: `Poliza_Garantia_${p.num_serie}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
      };

      await html2pdf().set(opt).from(element).save();
      document.body.removeChild(tempDiv);
    } catch (error) {
      console.error('Error al generar PDF:', error);
      window.toast?.error('Error al generar PDF');
    }
  },

  // =====================================================
  // FIRMAS
  // =====================================================

  async initFirmas() {
    if (!window.SignaturePad) {
      await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/signature_pad/4.1.7/signature_pad.umd.min.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    // Resetear pads previos para que subirFirmas no re-suba firmas ya persistidas
    this.signaturePad_empresa = null;
    this.signaturePad_cliente = null;

    setTimeout(() => {
      ['empresa', 'cliente'].forEach(tipo => {
        const canvas = document.getElementById(`firma-${tipo}`);
        if (!canvas) return;

        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d').scale(ratio, ratio);

        const pad = new SignaturePad(canvas, {
          backgroundColor: 'rgb(255, 255, 255)',
          penColor: 'rgb(0, 0, 0)'
        });

        this[`signaturePad_${tipo}`] = pad;

        const placeholder = canvas.parentElement.querySelector('.firma-placeholder');
        const hideOnDraw = () => { if (placeholder) placeholder.style.display = 'none'; };
        canvas.addEventListener('pointerdown', hideOnDraw);
        canvas.addEventListener('touchstart', hideOnDraw);

        // Activar "Hay cambios sin guardar" al terminar un trazo
        if (this._showUnsaved) pad.addEventListener('endStroke', () => this._showUnsaved());
      });
    }, 100);
  },

  _showProgress(message) {
    let overlay = document.getElementById('progressOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'progressOverlay';
      overlay.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 9999;';
      overlay.innerHTML = `
        <div class="spinner" style="margin-bottom: 1rem;"></div>
        <p id="progressMessage" style="font-size: 1rem; font-weight: 600; color: var(--gray-700);"></p>
      `;
      document.body.appendChild(overlay);
    }
    document.getElementById('progressMessage').textContent = message;
  },

  _hideProgress() {
    const overlay = document.getElementById('progressOverlay');
    if (overlay) overlay.remove();
  },

  _showUnsaved() {
    this._hasUnsaved = true;
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator) indicator.style.display = 'block';
  },

  _clearUnsaved() {
    this._hasUnsaved = false;
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator) indicator.style.display = 'none';
  },

  limpiarFirma(tipo) {
    const pad = this[`signaturePad_${tipo}`];
    if (pad) {
      pad.clear();
      const canvas = document.getElementById(`firma-${tipo}`);
      const placeholder = canvas?.parentElement.querySelector('.firma-placeholder');
      if (placeholder) placeholder.style.display = 'block';
    }
  },

  limpiarFirmaExistente(tipo) {
    const p = this.data.poliza;
    if (tipo === 'empresa') p.firma_empresa_url = null;
    if (tipo === 'cliente') p.firma_cliente_url = null;
    this.renderPolizaExistente();
    this._showUnsaved();
  },

  async toBlob(signaturePad) {
    const dataURL = signaturePad.toDataURL('image/png');
    const response = await fetch(dataURL);
    return response.blob();
  },

  async subirFirmas() {
    const urls = { firma_empresa_url: null, firma_cliente_url: null };
    const uploads = [];

    const padEmpresa = this.signaturePad_empresa;
    const padCliente = this.signaturePad_cliente;

    const numSerie = this.data.poliza?.num_serie;

    if (padEmpresa && !padEmpresa.isEmpty()) {
      uploads.push(
        recepcionService.subirFirma(await this.toBlob(padEmpresa), `firma-empresa-poliza-${Date.now()}.png`, numSerie, 'poliza')
          .then(url => { urls.firma_empresa_url = url; })
      );
    }

    if (padCliente && !padCliente.isEmpty()) {
      uploads.push(
        recepcionService.subirFirma(await this.toBlob(padCliente), `firma-cliente-poliza-${Date.now()}.png`, numSerie, 'poliza')
          .then(url => { urls.firma_cliente_url = url; })
      );
    }

    await Promise.all(uploads);
    return urls;
  },

  async completarPoliza() {
    const p = this.data.poliza;

    if (this._hasUnsaved) {
      toast.warning('Primero debes guardar los cambios antes de completar');
      return;
    }

    // Validar firmas antes de abrir el modal de confirmación
    const padEmpresa = this.signaturePad_empresa;
    const padCliente = this.signaturePad_cliente;
    const tieneFirmaEmpresa = !!p.firma_empresa_url || (padEmpresa && !padEmpresa.isEmpty());
    const tieneFirmaCliente = !!p.firma_cliente_url || (padCliente && !padCliente.isEmpty());

    if (!tieneFirmaEmpresa || !tieneFirmaCliente) {
      toast.error('Se requieren ambas firmas para completar la póliza');
      return;
    }

    window.modal.confirm(
      'Completar Póliza',
      '¿Está seguro de completar la póliza? Una vez completada no se podrán modificar las firmas.',
      async () => {
        try {
          this._showProgress('Subiendo firmas...');
          const firmasNuevas = await this.subirFirmas();
          const firma_empresa = firmasNuevas.firma_empresa_url || p.firma_empresa_url;
          const firma_cliente = firmasNuevas.firma_cliente_url || p.firma_cliente_url;

          this._showProgress('Completando póliza...');
          await posventaService.actualizarPoliza(p.id, {
            firma_empresa_url: firma_empresa,
            firma_cliente_url: firma_cliente,
            completada: true
          });
          this._hideProgress();
          this._clearUnsaved();
          toast.success('Póliza completada exitosamente');
          await this.cargarPoliza(p.id);
        } catch (error) {
          this._hideProgress();
          toast.error(error.message || 'Error al completar póliza');
        }
      }
    );
  },

  eliminarPoliza() {
    const p = this.data.poliza;
    window.modal.confirm(
      'Eliminar Póliza',
      `¿Está seguro de eliminar la póliza del tractor ${p.num_serie}? Esta acción no se puede deshacer.`,
      async () => {
        try {
          this._showProgress('Eliminando póliza...');
          await posventaService.eliminarPoliza(p.id);
          this._hideProgress();
          window.toast.success('Póliza eliminada correctamente');
          router.navigate('/posventa/polizas');
        } catch (error) {
          this._hideProgress();
          console.error('Error al eliminar póliza:', error);
          window.toast.error(error.message || 'Error al eliminar póliza');
        }
      }
    );
  }
};
